// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"cgPab":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createEventsObservable = require("@mediajel/tracker-core/utils/create-events-observable");
var _createEventsObservableDefault = parcelHelpers.interopDefault(_createEventsObservable);
var _isTrackerLoaded = require("@mediajel/tracker-core/sources/utils/is-tracker-loaded");
var _safeDom = require("@mediajel/tracker-core/utils/safe-dom");
var _transDeduplicator = require("@mediajel/tracker-core/sources/utils/trans-deduplicator");
var _xhrResponseSource = require("@mediajel/tracker-core/sources/xhr-response-source");
var _pollForElement = require("@mediajel/tracker-core/sources/utils/poll-for-element");
// TODO: Use dataLayerSource?
// TODO: Don't use 'key' for storage, use HOC extension
const magentoDataSource = ()=>{
    if (window.location.href.includes("/thank-you")) {
        const elements = [
            ".flex.flex-col.lg\\:flex-row.lg\\:space-x-8"
        ]; // Waits for inner div to load (it loads the purchase data)
        (0, _pollForElement.pollForElement)(elements, ()=>{
            // isTrackerLoaded(() => {
            window.dataLayer = window.dataLayer || [];
            for(let i = 0; i < window.dataLayer.length; i++){
                const data = window.dataLayer[i];
                if (data.event === "purchase") {
                    const ecommerce = data.ecommerce;
                    (0, _isTrackerLoaded.isTrackerLoaded)(()=>{
                        (0, _transDeduplicator.runOncePerPageLoad)(()=>{
                            (0, _createEventsObservableDefault.default).notify({
                                transactionEvent: {
                                    id: ecommerce.transaction_id.toString(),
                                    total: parseFloat(ecommerce.value),
                                    tax: parseFloat(ecommerce.tax) || 0,
                                    shipping: parseFloat(ecommerce.shipping) || 0,
                                    city: "N/A",
                                    country: "USA",
                                    currency: "USD",
                                    couponCode: ecommerce.coupon || "N/A",
                                    discount: parseFloat(ecommerce.discount) || 0,
                                    state: "N/A",
                                    items: ecommerce.items.map((item)=>{
                                        return {
                                            orderId: ecommerce.transaction_id.toString(),
                                            sku: item.item_id.toString(),
                                            name: (item.item_name || "N/A").toString(),
                                            category: (item.item_category || "N/A").toString(),
                                            unitPrice: parseFloat(item.price || 0),
                                            quantity: parseInt(item.quantity || 1),
                                            currency: "USD"
                                        };
                                    })
                                }
                            });
                            sessionStorage.setItem("key", "loaded");
                        });
                    });
                }
            }
        // datalayerSource((data: any): void => {
        //   if (data.event === "purchase") {
        //     const ecommerce = data.ecommerce;
        //     observable.notify({
        //       transactionEvent: {
        //         id: ecommerce.transaction_id.toString(),
        //         total: parseFloat(ecommerce.value),
        //         tax: parseFloat(ecommerce.tax) || 0,
        //         shipping: parseFloat(ecommerce.shipping) || 0,
        //         city: "N/A",
        //         country: "USA",
        //         currency: "USD",
        //         state: "N/A",
        //         items: ecommerce.items.map((item: any) => {
        //           return {
        //             orderId: ecommerce.transaction_id.toString(),
        //             sku: item.item_id.toString(),
        //             name: (item.item_name || "N/A").toString(),
        //             category: (item.item_category || "N/A").toString(),
        //             unitPrice: parseFloat(item.price || 0),
        //             quantity: parseInt(item.quantity || 1),
        //             currency: "USD",
        //           } as TransactionCartItem;
        //         }),
        //       },
        //     });
        //     sessionStorage.setItem("key", "loaded");
        //   }
        // });
        // });
        });
    }
    if (!sessionStorage.getItem("key")) {
        window.dataLayer = window.dataLayer || [];
        for(let i = 0; i < window.dataLayer.length; i++){
            const data = window.dataLayer[i];
            if (data.event === "purchase") {
                const ecommerce = data.ecommerce;
                (0, _isTrackerLoaded.isTrackerLoaded)(()=>{
                    (0, _transDeduplicator.runOncePerPageLoad)(()=>{
                        (0, _createEventsObservableDefault.default).notify({
                            transactionEvent: {
                                id: ecommerce.transaction_id.toString(),
                                total: parseFloat(ecommerce.value),
                                tax: parseFloat(ecommerce.tax) || 0,
                                shipping: parseFloat(ecommerce.shipping) || 0,
                                city: "N/A",
                                country: "USA",
                                currency: "USD",
                                state: "N/A",
                                items: ecommerce.items.map((item)=>{
                                    return {
                                        orderId: ecommerce.transaction_id.toString(),
                                        sku: item.id.toString(),
                                        name: (item.name || "N/A").toString(),
                                        category: (item.category || "N/A").toString(),
                                        unitPrice: parseFloat(item.price || 0),
                                        quantity: parseInt(item.quantity || 1),
                                        currency: "USD"
                                    };
                                })
                            }
                        });
                        sessionStorage.setItem("key", "loaded");
                    });
                });
            }
        }
    }
    (0, _xhrResponseSource.xhrResponseSource)((xhr)=>{
        try {
            const getData = JSON.parse(xhr.responseText);
            const products = getData && getData.items;
            if (products !== undefined || products.length !== 0) {
                const dataToJSON = JSON.stringify(getData);
                sessionStorage.setItem("pixelData", dataToJSON);
            }
        } catch (e) {}
    });
    if (window.location.pathname.includes("/checkout/onepage/success/") || window.location.pathname.includes("/success/")) setTimeout(()=>{
        try {
            const storedData = sessionStorage.getItem("pixelData");
            const retrievedObject = JSON.parse(storedData !== null && storedData !== void 0 ? storedData : "null");
            const productsList = retrievedObject && retrievedObject.items;
            const checkoutSuccessElement = (0, _safeDom.queryEl)(".checkout-success");
            // Scope the order-number lookup to the success container; never fall back to a
            // page-wide <span> search (queryText defaults root to document on undefined).
            const orderNumber = checkoutSuccessElement ? (0, _safeDom.queryText)("span", "", checkoutSuccessElement) : "";
            (0, _createEventsObservableDefault.default).notify({
                transactionEvent: {
                    id: orderNumber,
                    total: parseFloat(retrievedObject.base_grand_total),
                    tax: parseFloat(retrievedObject.base_tax_amount) || 0,
                    shipping: parseFloat(retrievedObject.base_shipping_amount) || 0,
                    city: "N/A",
                    state: "N/A",
                    country: "N/A",
                    currency: "USD",
                    items: productsList.map((product)=>{
                        const { item_id, name, price, qty } = product;
                        return {
                            orderId: orderNumber.toString(),
                            productId: item_id.toString(),
                            sku: item_id.toString(),
                            name: (name || "N/A").toString(),
                            category: "N/A",
                            unitPrice: parseFloat(price || 0),
                            quantity: parseInt(qty || 1),
                            currency: "USD"
                        };
                    })
                }
            });
        } catch (error) {
        // window.tracker("trackError", JSON.stringify(error), "MAGENTO");
        }
        sessionStorage.setItem("pixelData", "0");
    }, 1000);
};
exports.default = magentoDataSource;

},{"@mediajel/tracker-core/utils/create-events-observable":"mgAWw","@mediajel/tracker-core/sources/utils/is-tracker-loaded":"egswQ","@mediajel/tracker-core/utils/safe-dom":"f8Z89","@mediajel/tracker-core/sources/utils/trans-deduplicator":"8V1Xp","@mediajel/tracker-core/sources/xhr-response-source":"7YrGZ","@mediajel/tracker-core/sources/utils/poll-for-element":"eIoH9","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"egswQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTrackerLoaded", ()=>isTrackerLoaded);
var _guard = require("@mediajel/tracker-core/utils/guard");
const isTrackerLoaded = (callback)=>{
    const safeCallback = (0, _guard.guard)(callback, "tracker-loaded");
    if (typeof window.tracker === "function") safeCallback();
    else {
        let trackerLoaded = false;
        const intervalId = setInterval(()=>{
            if (typeof window.tracker === "function" && !trackerLoaded) {
                trackerLoaded = true;
                clearInterval(intervalId);
                safeCallback();
            }
        }, 100);
    }
};

},{"@mediajel/tracker-core/utils/guard":"8CHY0","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"f8Z89":[function(require,module,exports) {
/**
 * Safe DOM helpers for tag code that runs on arbitrary client pages.
 * They never throw when an element is missing.
 */ /**
 * Returns the trimmed `textContent` of the first element matching `selector`,
 * or `fallback` (default "") when the element or its text is absent.
 * Optional `root` scopes the query (e.g. a previously found container element).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryText", ()=>queryText);
parcelHelpers.export(exports, "queryEl", ()=>queryEl);
const queryText = (selector, fallback = "", root = document)=>{
    var _root_querySelector_textContent, _root_querySelector;
    var _root_querySelector_textContent_trim;
    return (_root_querySelector_textContent_trim = (_root_querySelector = root.querySelector(selector)) === null || _root_querySelector === void 0 ? void 0 : (_root_querySelector_textContent = _root_querySelector.textContent) === null || _root_querySelector_textContent === void 0 ? void 0 : _root_querySelector_textContent.trim()) !== null && _root_querySelector_textContent_trim !== void 0 ? _root_querySelector_textContent_trim : fallback;
};
const queryEl = (selector, root = document)=>{
    return root.querySelector(selector);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"8V1Xp":[function(require,module,exports) {
/*
 *   Saves a key on the session storage to indicate that the tracker has been
 *   loaded once, this will prevent multiple triggering of the code
 *   even without reloading the page. And when the user reloads the page,
 *   the key will be removed and placed again.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "runOncePerPageLoad", ()=>runOncePerPageLoad);
var _logger = require("@mediajel/tracker-core/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
const runOncePerPageLoad = (callback)=>{
    const key = "key";
    if (!sessionStorage.getItem(key)) {
        (0, _loggerDefault.default).info("First run in this session");
        callback();
        sessionStorage.setItem(key, "loaded");
    } else (0, _loggerDefault.default).info("Already run in this session");
    // Listen for the unload event to reset the sessionStorage item
    window.addEventListener("beforeunload", ()=>{
        sessionStorage.removeItem("key");
    });
    // Listen for page changes to reset the sessionStorage item
    window.addEventListener("popstate", ()=>{
        sessionStorage.removeItem("key");
    });
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    history.pushState = function(...args) {
        originalPushState.apply(this, args);
        sessionStorage.removeItem("key");
        window.dispatchEvent(new Event("popstate"));
    };
    history.replaceState = function(...args) {
        originalReplaceState.apply(this, args);
        sessionStorage.removeItem("key");
        window.dispatchEvent(new Event("popstate"));
    };
};

},{"@mediajel/tracker-core/logger":"1YoS6","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"7YrGZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xhrResponseSource", ()=>xhrResponseSource);
var _guard = require("@mediajel/tracker-core/utils/guard");
const xhrResponseSource = (callback)=>{
    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(...args) {
        this.addEventListener("load", (0, _guard.guard)(()=>callback(this), "xhr-response"));
        origOpen.apply(this, args);
    };
};

},{"@mediajel/tracker-core/utils/guard":"8CHY0","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}]},[], null, "parcelRequire07df")

//# sourceMappingURL=magento.82950fab.js.map
